<template>
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item style="margin-left: -5%;">
      <el-radio-group v-model="form.model.productType">
        <el-radio :label="10">普通产品</el-radio>
        <el-radio :label="20">旅游产品</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.productName">
      <el-input v-model="form.model.productName" class="max-w460" placeholder="请输入商品名称"></el-input>
    </el-form-item>
    <el-form-item label="商品编码：">
      <el-input v-model="form.model.productNo" class="max-w460" placeholder="请输入商品编码"></el-input>
    </el-form-item>
    <el-form-item label="所属分类：" :rules="[{ required: form.model.productType===10?true:false, message: '请选择所属分类', trigger: 'change'  }]"
      prop="model.categoryId">
      <el-select v-model="form.model.categoryId" placeholder="请选择所属分类">
        <template v-for="cat in form.category">
          <el-option :value="cat.categoryId" :key="cat.categoryId" :label="cat.name"></el-option>
          <template v-for="two in cat.children">
            <el-option :value="two.categoryId" :key="two.categoryId" :label="two.name" style="padding-left: 30px;"></el-option>
          </template>
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="商品分类：" :rules="[{ required: form.model.productType===10?true:false, message: '请选择所属分类', trigger: 'change'  }]"
      prop="model.receiptType">
      <el-select v-model="form.model.receiptType" placeholder="请选择商品分类">
        <template v-for="cat in receiptList">
          <el-option :value="cat.value" :key="cat.value" :label="cat.name"></el-option>
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="销售状态：">
      <el-radio-group v-model="form.model.productStatus">
        <el-radio :label="10">立即上架</el-radio>
        <el-radio :label="20">放入仓库</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品版本：">
      <el-radio-group v-model="form.model.edition">
        <el-radio :label="1">押金版</el-radio>
        <el-radio :label="2">无押版</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品类型：">
      <el-radio-group v-model="form.model.versions" @input="changeVersion">
        <el-radio :label="1">1.0</el-radio>
        <el-radio :label="2">2.0</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="享受类型：">
      <el-radio-group v-model="form.model.enjoyment">
        <el-radio :label="1">享受提成</el-radio>
        <el-radio :label="2">享受pos币</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="商品图片：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.image" :key="item.filePath">
              <img v-img-url="item.filePath" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <!-- <el-form-item label="商品视频：">
      <el-row>
        <div class="draggable-list">
          <div class="item img-select" v-if="form.model.videoId==0" @click="openProductUpload('video', 'video')"><i class="el-icon-plus"></i></div>
          <div v-if="form.model.videoId!=0">
            <video width="150" height="150" :src="form.model.videoFilePath" :autoplay="false" controls>
              您的浏览器不支持 video 标签
            </video>
            <div>
              <el-button icon="el-icon-picture-outline" @click="delVideo">删除视频</el-button>
            </div>
          </div>
        </div>
      </el-row>
    </el-form-item> -->
    <!-- <el-form-item label="视频封面：">
      <el-row>
        <div class="draggable-list">
          <div class="item img-select" v-if="form.model.posterId==0" @click="openProductUpload('image', 'poster')"><i class="el-icon-plus"></i></div>
          <div v-if="form.model.posterId!=0" class="item" @click="openProductUpload('image', 'poster')">
            <img :src="form.model.posterFilePath" width="100" height="100" />
          </div>
        </div>
      </el-row>
    </el-form-item> -->
    <el-form-item label="商品卖点：">
      <el-input type="textarea" v-model="form.model.sellingPoint" class="max-w460" placeholder="请输入商品卖点"></el-input>
    </el-form-item>

    <!--其他设置-->
    <div class="common-form mt50">其他设置</div>
    <el-form-item label="商品属性：">
      <el-radio-group v-model="form.model.isVirtual">
        <el-radio :label="0">实物商品</el-radio>
        <el-radio :label="1">虚拟商品(无需发货)</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="运费模板：" :rules="[{ required: true, message: '选择运费模板' }]" prop="model.deliveryId" v-if="form.model.isVirtual==0">
      <el-select v-model="form.model.deliveryId" placeholder="请选择运费模板">
        <el-option v-for="item in form.delivery" :value="item.deliveryId" :key="item.deliveryId" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="初始销量：">
      <el-input type="number" min="0" v-model="form.model.salesInitial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.productSort">
      <el-input type="number" min="0" v-model="form.model.productSort" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="限购数量：" :rules="[{ required: true, message: ' ' }]" prop="model.limitNum">
      <el-input type="number" min="0" v-model="form.model.limitNum" class="max-w460"></el-input>
      <div class="gray9">每个会员购买的最大数量，0为不限购</div>
    </el-form-item>
    <el-form-item label="发货类型：" v-if="form.model.isVirtual==1">
      <el-radio-group v-model="form.model.virtualAuto">
        <el-radio :label="1">自动</el-radio>
        <el-radio :label="0">手动</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="虚拟内容：" :rules="[{ required: true, message: '请填写虚拟内容' }]" prop="model.virtualContent" v-if="form.model.isVirtual==1">
      <el-input type="text" v-model="form.model.virtualContent" class="max-w460"></el-input>
      <div class="gray9">虚拟物品内容</div>
    </el-form-item>
    <el-form-item label="购买享受等级：">
      <el-select size="small" v-model="form.model.planbLevel" placeholder="所有B套餐会员等级" style="width: 460px;">
        <el-option v-for="(item, index) in agentGradeList" :key="index" :label="item.name" :value="item.gradeId"></el-option>
      </el-select>
      <div class="gray9">购买此商品享受对应的等级</div>
    </el-form-item>
    <el-form-item label="会员等级限制：">
      <el-select v-model="form.model.gradeIds" multiple placeholder="请选择会员等级限制" style="width: 460px;">
        <el-option v-for="item in form.gradeList" :key="item.gradeId" :label="item.name" :value="item.gradeId">
        </el-option>
      </el-select>
      <div class="gray9">仅设置的等级会员可购买，不设置则都可以购买</div>
    </el-form-item>
    <el-form-item label="激活奖：">
      &nbsp;&nbsp;&nbsp; 首刷&nbsp;&nbsp;&nbsp;<el-input v-model="form.model.active.number" class="inp" size="small"></el-input>
      元，返&nbsp;&nbsp;&nbsp;<el-input class="inp" size="small" v-model="form.model.active.back"></el-input> 元 <i class="el-icon-plus"></i>
      <el-input class="inp" size="small" v-model="form.model.active.exchange"></el-input> 券
    </el-form-item>
    <el-form-item label="达标奖：">
      <div class="flex" v-for="(item,index) in form.model.compliance.compliance" :key="index">
        <div> <el-input v-model="item.startDay" size="small" class="inp2" @input="handleInput(index,'startDay')"></el-input>&nbsp;&nbsp;&nbsp;天到&nbsp;&nbsp;&nbsp;<el-input v-model="item.endDay" size="small" class="inp2" @input="handleInput(index,'endDay')"></el-input>天刷&nbsp;&nbsp;&nbsp;<el-input v-model="item.number" size="small" class="inp" @input="handleInput2(index,'number')"></el-input>
      元，返&nbsp;&nbsp;&nbsp;<el-input size="small" class="inp" v-model="item.back" @input="handleInput2(index,'back')"></el-input> 元</div>
          <div class="icon" @click="addCompliance()"><i class="el-icon-circle-plus-outline" style="font-size: 24px;color:#409eff;"></i></div>
          <div v-if="form.model.compliance.compliance.length>1" class="icon" @click="delCompliance(index)"><i class="el-icon-remove-outline" style="font-size: 24px;color:#409eff;"></i></div>
      </div>
    </el-form-item>
    <div style="display:flex">
        <el-form-item label="零售利润类型：">
          <el-select style="width: 150px" v-model="form.model.retailMarginType" size="small" clearable>
            <el-option v-for="item in retailMarginType" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      <el-form-item label="零售利润：">
       <div style="position:relative">
        <el-input-number style="width:150px" v-model="form.model.retailMargin" :controls="false" :max="100"></el-input-number><i class="unit" v-if="form.model.retailMarginType==0">%</i>
       </div>
      </el-form-item>
    </div>
    <el-form-item label="押金：">
      <div class="flex" v-for="(item,index) in form.model.cashBackDeposit.cashBackDeposit" :key="index">
        <div> <el-input v-model="item.number" size="small" class="inp"></el-input>元,
          返<el-input v-model="item.back" size="small" class="inp"></el-input>元</div>
        <div class="icon" @click="addCompliance2()"><i class="el-icon-circle-plus-outline" style="font-size: 24px;color:#409eff;"></i></div>
        <div v-if="form.model.cashBackDeposit.cashBackDeposit.length>1" class="icon" @click="delCompliance2(index)"><i class="el-icon-remove-outline" style="font-size: 24px;color:#409eff;"></i></div>
      </div>
    </el-form-item>
    <el-form-item label="流量卡扣：">
      周期一：<el-input v-model="form.model.trafficCard.oneStartDay" size="small" class="inp"></el-input>天-
      <el-input v-model="form.model.trafficCard.oneEndDay" size="small" class="inp"></el-input>天,刷
      <el-input v-model="form.model.trafficCard.oneNumber" size="small" class="inp"></el-input>元,
      返<el-input v-model="form.model.trafficCard.oneBack" size="small" class="inp"></el-input>元
    </el-form-item>
    <el-form-item label="流量卡扣：">
      周期二：<el-input v-model="form.model.trafficCard.towStartDay" size="small" class="inp"></el-input>天-
      <el-input v-model="form.model.trafficCard.towEndDay" size="small" class="inp"></el-input>天,刷
      <el-input v-model="form.model.trafficCard.towNumber" size="small" class="inp"></el-input>元,
      返<el-input v-model="form.model.trafficCard.towBack" size="small" class="inp"></el-input>元
    </el-form-item>
    <el-form-item label="流量卡扣：">
      周期三：<el-input v-model="form.model.trafficCard.threeStartDay" size="small" class="inp"></el-input>天-
      <el-input v-model="form.model.trafficCard.threeEndDay" size="small" class="inp"></el-input>天,刷
      <el-input v-model="form.model.trafficCard.threeNumber" size="small" class="inp"></el-input>元,
      返<el-input v-model="form.model.trafficCard.threeBack" size="small" class="inp"></el-input>元
    </el-form-item>
    <el-form-item label="">
      <el-input v-model="form.model.noActivatedDeduction.day" size="small" class="inp"></el-input>天未激活
      扣除代理商<el-input v-model="form.model.noActivatedDeduction.number" size="small" class="inp"></el-input>元,
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  import distributionApi from '@/api/plus/distribution.js';
  export default {
    components: {
      Upload,
      draggable
    },
    data() {
      return {
        retailMarginType:[
          {
            name:'按比例',
            value:0
          },
          {
            name:'按台',
            value:1
          }
        ],
        isProductUpload: false,
        config: {},
        file_name: 'image',
        receiptList: [{
            name: 'ZPOS-电签',
            value: 1
          },
          {
            name: 'FPOS-大机',
            value: 2
          },
          {
            name: 'ZPOS-买断版',
            value: 3
          },
          {
            name: 'FPOS-买断版',
            value: 4
          },
          {
            name: '和融通',
            value: 5
          },
          {
            name: '合利宝',
            value: 6
          },
          {
            name: '电银',
            value: 7
          },
          {
            name: '联动支付',
            value: 8
          }
        ],
        /*B套餐*/
        agentGradeList: [],
      };
    },
    inject: ['form'],
    created() {
      this.agentGrade();
    },
    methods: {
      handleInput(index,name){
        let self  =this
        self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace(/[^\d]/g, '')
      },
      handleInput2(index,name){
        let self  =this
         // 只允许输入数字和小数点，保留两位小数
         self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace(/[^\d.]/g, ''); // 只保留数字和小数点
         self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace(/^\./g, ''); // 第一个字符不是小数点
         self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace(/\.{2,}/g, '.'); // 不允许多个小数点
         self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.'); // 只保留一个小数点
         self.form.model.compliance.compliance[index][name] = self.form.model.compliance.compliance[index][name].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只保留两位小数
      },
      changeVersion(){
        this.form.model.planbLevel = null
        this.agentGrade()
      },

      addCompliance(){
        this.form.model.compliance.compliance.push({
          startDay:'',
          endDay:'',
          number:'',
          back:''
        })
      },
      addCompliance2(){
        this.form.model.cashBackDeposit.cashBackDeposit.push({
          number: null,
          back: null
        })
      },
      delCompliance(index){
        this.form.model.compliance.compliance.splice(index,1)
      },
      delCompliance2(index){
        this.form.model.cashBackDeposit.cashBackDeposit.splice(index,1)
      },
      /*获取B套餐列表*/
      agentGrade() {
        distributionApi.getListPlanB({
          version: this.form.model.versions?parseInt(this.form.model.versions):1
        }).then(res => {
          console.log('B套餐表格数据', res)
          this.agentGradeList = res.data;
        }).catch(err => {
          console.log(err)
        })
      },
      /*打开上传图片*/
      openProductUpload: function(file_type, file_name) {
        this.file_name = file_name;
        if (file_type == 'image') {
          this.config = {
            total: 9,
            fileType: 'image'
          };
        } else {
          this.config = {
            total: 1,
            fileType: 'video'
          };
        }
        this.isProductUpload = true;
      },

      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          if (this.file_name == 'video') {
            this.form.model.videoId = e[0].fileId;
            this.form.model.videoFilePath = e[0].filePath;
          } else if (this.file_name == 'image') {
            let imgs = this.form.model.image.concat(e);
            // 兼容后端
            for (let i = 0; i < imgs.length; i++) {
              if (typeof(imageId) == "undefined") {
                this.$set(imgs[i], 'imageId', imgs[i].fileId);
              }
            }
            this.$set(this.form.model, 'image', imgs);
          } else if (this.file_name == 'poster') {
            this.form.model.posterId = e[0].fileId;
            this.form.model.posterFilePath = e[0].filePath;
          }
        }
        this.isProductUpload = false;
      },

      /*删除商品图片*/
      deleteImg(index) {
        this.form.model.image.splice(index, 1);
      },
      delVideo() {
        this.form.model.videoId = 0;
        this.form.model.video = {};
      },
    }
  };
</script>

<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    line-height: 20px;
    color: #2c3e50;
  }

  .ql-editor {
    height: 400px;
  }

  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .inp {
    width: 120px;
  }
  .inp2 {
    width: 60px;
  }
  .unit{
    position: absolute;
    top: 0;
    right: 10px;
  }
</style>
<style lang="scss" scoped>
  .flex{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &:nth-last-of-type(1){
      margin-bottom:0;
    }
    .icon{
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue